export default __webpack_public_path__ + "static/media/our-process-teb-img.00ab05bb.jpg";